import React, { Component } from "react";
import { connect } from "react-redux";
import NavBar from "../NavBar";
import CategoryBar from "../CategoryBar";
import CustomerTypeBar from "../CustomerTypeBar";
import { hideViewDetail, reset } from "../../actions/product";
import { showScrollView, scrollTo } from "../../actions/view";
import { goBack } from 'connected-react-router';
import AddressBar from "../../components/AddressBar";
import * as addressReducer from "../../reducers/addressReducer";
import * as page from "../../reducers/pageReducer";
import Headroom from "react-headroom";
import { checkOutUri, cartUri, rootPageUri } from "../../config/uri";
import * as uri from "../../config/uri";
import UpdateNavBar from "../../components/UpdateNavBar";
import {
  isProductsPage, 
  isItem, 
  isCheckout, 

  isSearchResult,
  isSuggestionPage,
  isRefinePathOpenMobile
} from "../../helpers/urlParts";
import {
  isLogoAndItemTypeBarFixed,
  isPaymentKiosk as isPaymentKioskSelector,
  isEcommerceSearchBarEnabled,
  isCustomerTypeOptionEnabled,
  isPhoneSelector,
  isEcommerceCollectionBarEnabled
} from "../../selectors/configSelectors";
import "./header.css";
import { isMainPageOpen, isRefineOpenMobile } from '../../selectors/router_selector';
import { openCloseAdvancedFilter, closeIfOpenAdvancedFilter } from "../../reducers/filterReducer";
import { flipLayout } from "../../reducers/viewReducer";
import { getCurrentLayoutType } from "../../selectors/viewSelectors";
import CollectionBar from "../CollectionBar/CollectionBar";
import { pushWithQueryParams } from "../../services/uri";

const MARGIN_TOP = '125px';

class Header extends Component {
  header = null;
  state = { headerPin: true, contentHeight: "105px" };
  shouldComponentUpdate(nextProps, nextState) {
    const { router, detailView } = this.props;
    return (
      this.state.contentHeight !== nextState.contentHeight ||
      router.location.pathname !== nextProps.router.location.pathname ||
      detailView.isOpen !== nextProps.detailView.isOpen ||
      this.props.view.scrollDirection !== nextProps.view.scrollDirection ||
      this.props.view.layoutType !== nextProps.view.layoutType ||
      this.props.isAddressBarOpened !== nextProps.isAddressBarOpened ||
      this.state.headerPin !== nextState.headerPin
    );
  }

  componentWillMount() {
    this.setContentHeight();
  }

  componentDidUpdate() {
    this.setContentHeight();
  }
  // var node = ReactDOM.findDOMNode(this.refs['content']);
  // return node.clientHeight;
  setContentHeight = () => {
    if (this.props.detailView.isOpen) {
      this.setState({ contentHeight: "105px" });
    } else {
      this.setState({ contentHeight: this.getHeaderHeight() });
    }
  };

  handleBackBtnClick = () => {
    this.props.goBack();
  };

  handleMainPageClick = () => {
    const { detailView } = this.props;

    if (detailView.isOpen) {
      this.props.hideViewDetail();
      this.props.showScrollView();
    }

    if (this.props.isMainPage) {
      this.props.reset();
    }

    this.props.go(rootPageUri);
  };

  isDetailViewClosed = () => {
    return !this.props.detailView.isOpen;
  };

  /* addressbar that appears at the top */
  isAddressBarOpened = () => {
    const path = this.props.router.location.pathname;
    return (
      // this.props.isEcommerceEnabled &&
      this.props.isAddressBarOpened && isProductsPage(path)
    );
  };
  /* address bar that appears at the bottom on pages */
  isAddressBarBottom = () => {
    const path = this.props.router.location.pathname;
    return this.props.isAddressBarOpened && isProductsPage(path);
  };
  isCartPage = () => {
    const { router } = this.props;
    return router.location.pathname === cartUri;
  };
  isPageOpened = () => {
    const { router } = this.props;
    return router.location.pathname !== rootPageUri;
  };
  isCheckoutPage = () => {
    const { router } = this.props;
    return router.location.pathname === checkOutUri;
  };
  isBackBtn = () => {
    const path = this.props.router.location.pathname;
    return isItem(path);
  };
  isBackBtnoNAddressBar = () => {
    const { detailView } = this.props;
    if (!detailView.isOpen) {
      return false;
    }
    return true;
  };
  getPageTitle = () => {
    const { router, detailView } = this.props;
    if (router.location.pathname === rootPageUri && !detailView.isOpen) {
      return "";
    } else if (router.location.pathname === cartUri) {
      return "CART";
    } else if (router.location.pathname === checkOutUri) {
      return "CHECKOUT";
    } else {
      return "";
    }
  };

  isCategoryPage = () => {
    return this.props.router.location.pathname.indexOf("/category") === 0;
  };

  getHeaderHeight = () => {
    const path = this.props.router.location.pathname;
    const {
      isPaymentKiosk,
      isPhone,
    } = this.props;

    const height = isPhone ? 68 : 120;

    if (isPaymentKiosk) {
      return MARGIN_TOP;
    }

    if (isRefinePathOpenMobile(path)) {
      return `${height}px`;
    }

    if (isItem(path)) {
      return `${height + 10}px`;
    }

    if (this.props.isCustomerTypeOptionEnabled && isPhone) {
      return `${height + 150}px`;
    }

    if (isSearchResult(path)) {
      return `${height + 105}px`;
    }

    if (this.isAddressBarOpened()) {
      return `${height + 120}px`;
    }

    if (isProductsPage(path)) {
      return `${height + 85}px`;
    }

    return `${height}px`;
  };

  headerPin = () => {
    if (!this.isDetailViewClosed()) {
      this.setState({ headerPin: true });
    }
  };

  headerUnpin = () => {
    if (!this.isDetailViewClosed()) {
      this.setState({ headerPin: false });
    }
  };

  isCategoryBar = () => {
    const {router} = this.props;
    const path = router.location.pathname;
    return isProductsPage(path) || isSearchResult(path);
  };

  isCollectionBar = () => {
    const { isPhone, isEcommerceCollectionBarEnabled } = this.props; 
    return !isPhone && isEcommerceCollectionBarEnabled
  }

  isHeaderDisabled = () => {
    const path = this.props.router.location.pathname;
    return isProductsPage(path) && this.isHeaderFixed();
  };

  isHeaderFixed = () => this.props.isHeaderFixed;

  isSuggestionOpen = () => {
    const path = this.props.router.location.pathname;

    return isSuggestionPage(path);
  }

  openCloseAdvancedFilter = () => {
    const {
      isPhone,
      redirectToFilter,
      openCloseAdvancedFilter,
      resetScrollPosition,
      isRefineOpenMobile,
      isMainPage,
    } = this.props;
    resetScrollPosition();

    if (isPhone) {
      if (isRefineOpenMobile) {
        this.props.goBack();
      } else {
        redirectToFilter();
      }
      return;
    }

    if (!isMainPage) {
      this.handleMainPageClick();
    }

    openCloseAdvancedFilter();
  }

  flipLayout = () => {
    const {
      resetScrollPosition,
      flipLayout
    } = this.props;

    flipLayout();
    resetScrollPosition();
  }

  renderMainHeader = () => {
    const path = this.props.router.location.pathname;
    const needle = uri.updateDocsUri.substr(0, uri.updateDocsUri.indexOf(":"));

    if (path.indexOf(needle) === 0) return <UpdateNavBar />;
    return (
      <NavBar
        isAddressBarOpened={this.props.isAddressBarOpened}
        isBackBtnActive={this.isBackBtn()}
        mainPageClick={this.handleMainPageClick}
        onBackBtnClick={this.handleBackBtnClick}
        isCheckoutPage={this.isCheckoutPage()}       openCloseAdvancedFilter={this.openCloseAdvancedFilter}
        layoutType={this.props.layoutType}
        flipLayout={this.flipLayout}
      />
    );
  };

  render() {
    const { contentHeight } = this.state;
    const { isPhone } = this.props;
    return (
      <Headroom
        disableInlineStyles
        {...this.isHeaderDisabled() && { disable: true }}
        onUnpin={this.headerUnpin}
        onPin={this.headerPin}
        style={{display: this.isSuggestionOpen() ? 'none' : 'block' , height: contentHeight, zIndex: 2}}
        className={this.isHeaderDisabled() ? 'headroom-fixed' : ''}
      >
        <div
          ref={ref => {
            this.header = ref;
          }}
          className={"header-wrapper"}
        >
          {this.renderMainHeader()}
          <div>
            {this.isCategoryBar() && (
               <div>
                   {this.props.isCustomerTypeOptionEnabled &&
                       <div className="visible-mobile">
                           <CustomerTypeBar />
                       </div>
                   }
                   {this.isCollectionBar() && <CollectionBar />}
                   <CategoryBar />
               </div>
            )}
          </div>
          {this.isAddressBarOpened() && (
            <AddressBar
              isBackBtn={this.isBackBtnoNAddressBar()}
              onBackBtnClick={this.handleBackBtnClick}
            />
          )}
        </div>
      </Headroom>
    );
  }
}

const mapStateToProps = state => {
  return {
    view: state.view,
    detailView: state.detailView,
    router: state.router,
    layoutType: getCurrentLayoutType(state),
    isAddressBarOpened: addressReducer.isAddressBarOpened(state),
    isEcommerceSearchBarEnabled: isEcommerceSearchBarEnabled(state),
    isPageOpened: page.isPageOpened(state),
    isHeaderFixed: isLogoAndItemTypeBarFixed(state),
    isPaymentKiosk: isPaymentKioskSelector(state),
    isMainPage: isMainPageOpen(state),
    isPhone: isPhoneSelector(state),
    isRefineOpenMobile: isRefineOpenMobile(state),
    isCustomerTypeOptionEnabled: isCustomerTypeOptionEnabled(state),
    isEcommerceCollectionBarEnabled: isEcommerceCollectionBarEnabled(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetScrollPosition: () => dispatch(scrollTo(0)),
    reset: () => dispatch(reset()),
    go: path => dispatch(pushWithQueryParams(path)),
    goBack: () => dispatch(goBack()),
    hideViewDetail: () => dispatch(hideViewDetail()),
    showScrollView: () => dispatch(showScrollView()),
    openCloseAdvancedFilter: () => dispatch(openCloseAdvancedFilter()),
    closeIfOpenAdvancedFilter: () => dispatch(closeIfOpenAdvancedFilter()),
    redirectToFilter: () => dispatch(pushWithQueryParams(uri.filterUri)),
    flipLayout: () => dispatch(flipLayout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx